module.exports = __webpack_public_path__ + "img/cybo_logo_cybo.5f4da784.svg";